import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';
import { type IconSize } from './icon.model';

@Component({
  selector: 'lib-icon',
  styleUrl: './icon.component.css',
  templateUrl: './icon.component.html',
})
export class IconComponent {
  private readonly sanitizer = inject(DomSanitizer);

  name = input<string>();
  svg = input<string>();
  size = input<IconSize>('md');
  color = input<string>();

  readonly iconClass = computed(() => {
    return `msa-icon msa-icon--${this.size()}`;
  });

  readonly safeSvg = computed<SafeHtml | null>(() => {
    const svgMarkup = this.svg();
    return svgMarkup ? this.sanitizer.bypassSecurityTrustHtml(svgMarkup) : null;
  });
}
